import { render, staticRenderFns } from "./modelComposer.vue?vue&type=template&id=bda3e9a4&"
import script from "./modelComposer.vue?vue&type=script&lang=js&"
export * from "./modelComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports